export class Publisher {
    subscriptions = [];
    /**
     * Subscribe to a channel with a callback handler.
     * You can subscribe to partial channel names (start with check)
     * Return a token you can use to unsubscribe your callback.
     */
    subscribe(params) {
        const { channel, callback } = params;
        const token = Symbol();
        this.subscriptions.push({
            channel,
            callback,
            token,
        });
        return token;
    }
    // Removes a callback based subscription using a token returned from subscribe
    //
    unsubscribe(params) {
        const { token } = params;
        this.subscriptions = this.subscriptions.filter((sub) => sub.token !== token);
    }
    // Removes all registered channel event callbacks
    //
    clearSubscriptions() {
        this.subscriptions = [];
    }
    // Extending classes can use the publish method to send values to subscribed callbacks
    //
    publish(params) {
        const { channel, value } = params;
        const subs = this.subscriptions.filter((sub) => channel.startsWith(sub.channel));
        subs.forEach((sub) => sub.callback({ channel, value }));
    }
}
//# sourceMappingURL=publisher.js.map